<template>
  <div>
    <div class="footer_div">
      <div class="left">
        <div class="top">
          <h3>关于我们</h3>
          <p>
            程果少儿编程教育是国内青少儿编程及思维教育的开拓者,致力于4～16岁编程思维、数学逻辑思维、STEAM和创客教育课程，帮助孩子提升计算思维，空间思维，逻辑思维,创新与创作力。
          </p>
        </div>

        <div class="bottom">
          <h3>联系我们</h3>
          <ul>
            <li>
              <img src="../../assets/stylus/image/locationIcon2.png" />
              <span>安徽省安庆市迎江区金华联2F程果少儿编程</span>
            </li>
            <li>
              <img src="../../assets/stylus/image/messageIcon.png" />
              <span>chengguo@cgyounger.com</span>
            </li>
            <li>
              <img src="../../assets/stylus/image/telephoneIcon.png" />
              <span>客服电话：0556-5205510</span>
            </li>
          </ul>
          <div class="icp">
            皖ICP备20008103号 程果教育
          </div>
        </div>
      </div>

      <div class="right">
        <h3 style="font-size: 18px;">关注我们</h3>
        <el-popover
          placement="bottom"
          title="微信公众号"
          width="60"
          trigger="hover"
        >
          <img src="../../assets/stylus/image/wxgzh.jpg" style="width:100%;" />
          <img
            slot="reference"
            src="../../assets/stylus/image/wx.png"
            style="width:30px;margin-top:20px;cursor: pointer"
          />
        </el-popover>

        <el-popover
          placement="bottom"
          title="抖音官方号"
          width="60"
          trigger="hover"
          style="margin-left:16px;"
        >
          <img src="../../assets/stylus/image/wxgzh.jpg" style="width:100%;" />
          <img
            slot="reference"
            src="../../assets/stylus/image/dy.png"
            style="width:30px;margin-top:20px;cursor: pointer"
          />
        </el-popover>
      </div>
    </div>

    <!-- 回到顶部按钮 -->
    <el-backtop>
      <img
        class="backtop_img"
        style="width:100%;"
        src="../../assets/stylus/image/return_top.png"
      />
    </el-backtop>
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
 .footer_div {
  width: 100%;
  padding: 30px;
  display: flex;
  justify-content: space-between;
  color: #fff;
  background: #222;

  .left {
    width: 45%;

    .top {
      margin-bottom: 30px;
    }

    .bottom {
      ul {
        margin-top: 22px;

        li {
          font-size: 12px;
          margin-bottom: 12px;

          img {
            width: 14px;
            vertical-align: middle;
            margin-right: 6px;
          }
        }
      }

        .icp {
    color:#fff;
  }
    }

    h3 {
      font-size: 18px;
    }

    p {
      margin-top: 20px;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .right {
    width: 50%;
  }
}

.el-backtop {
  background:none;
}

.backtop_img {
  box-shadow: rgb(252 92 92 / 50%) 0px 2px 12px 0px;
  border-radius: 22px;
  position: relative;
  top: 0px;
  -webkit-animation: myfirst 2.2s infinite linear;
}

@keyframes myfirst {
0% {
  left: 0px;
  top: 6px;
}

25% {
  left: 0px;
  top: -6px;
}

50% {
  left: 0px;
  top: 6px;
}

75% {
  left: 0px;
  top: -6px;
}

100% {
  left: 0px;
  top: 6px;
}
}
</style>
